import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-500"></i>
              </div>
              <span className="text-base font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫大全
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩漫漫画网站，汇聚好看韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门合集，满足您的多元化口味。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-categories" className="hover:text-primary-500 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">动作漫画</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">悬疑漫画</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">搞笑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-links" className="hover:text-primary-500 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">网站首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-contact" className="hover:text-primary-500 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                contact@hanmandq.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-line text-sm"></i>
                </div>
                客服QQ：1234567890
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫大全 HanManDaQuan.com - 韩漫漫画网站，韩漫在线免费阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}